export default __webpack_public_path__ + "static/04-8cebe69f50ad57399447c2704e674bb0.jpg";